import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CustomerEffects, customerReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([CustomerEffects]), StoreModule.forFeature(`customer`, customerReducer)]
})
export class CustomerStateModule {}
